import getAllPlans from "./Plans";
import {
  newRegister,
  newRegisterV2,
  updateRegisterV2,
  updateRegister,
  checkout,
  checkoutV2,
  step,
} from "./Acquisition";
import { getAddress } from "./Address";
import {
  checkPhone,
  checkBalance,
  validEmailCode,
  resetPassword,
  changePassword,
  validCpf,
  forgotPwd,
} from "./Customer";
import {
  checkPortability,
  sendSmsPortability,
  checkSmsPortability,
  requestPortability,
  registerPortability,
} from "./Portability";
import { checkSms, createTokenCard } from "./Token";
import { getTerms, sendTermsOnEmail } from "./Regulations";
import { getCart } from "./Cart";
import { getSubscription } from "./Subscription";
import { checkAntifraud } from "./Antifraud";
import { checkCupom, validateCoupon } from "./Coupon";
import { saveCard } from "./CreditCard";
import { getTokenChat } from "./Chat";
import { getTokenM4U } from "./M4U";

export default {
  getAllPlans,
  newRegister,
  getAddress,
  checkPhone,
  checkSms,
  checkBalance,
  getTerms,
  sendTermsOnEmail,
  getCart,
  checkout,
  checkoutV2,
  checkAntifraud,
  getSubscription,
  newRegisterV2,
  updateRegisterV2,
  forgotPwd,
  resetPassword,
  validEmailCode,
  changePassword,
  validCpf,
  updateRegister,
  checkCupom,
  validateCoupon,
  createTokenCard,
  saveCard,
  step,
  getTokenChat,
  getTokenM4U,
  registerPortability,
  checkPortability,
  sendSmsPortability,
  checkSmsPortability,
  requestPortability,
};
